import React, { useState } from 'react';
import AllMarketingExecutions from './AllMarketingExecutions';
import MarketingExecution from './MarketingExecution';

const MarketingExecutionWrapper: React.FC = () => {
  const [selectedExecutionId, setSelectedExecutionId] = useState<string | null>(null);
  const [selectedExecutionName, setSelectedExecutionName] = useState<string>('');

  const handleExecutionSelect = (executionId: string, executionName: string) => {
    console.log('Wrapper: Execution selected:', executionId, executionName);
    setSelectedExecutionId(executionId);
    setSelectedExecutionName(executionName);
  };

  const handleBackToExecutions = () => {
    console.log('Wrapper: Back to executions');
    setSelectedExecutionId(null);
    setSelectedExecutionName('');
  };

  console.log('Wrapper render - selectedExecutionId:', selectedExecutionId, 'selectedExecutionName:', selectedExecutionName);

  if (selectedExecutionId) {
    console.log('Wrapper: Rendering MarketingExecution component');
    return (
      <MarketingExecution 
        planId={selectedExecutionId} 
        planName={selectedExecutionName || `Execution ${selectedExecutionId}`} 
        onBackToPlans={handleBackToExecutions} 
      />
    );
  }

  console.log('Wrapper: Rendering AllMarketingExecutions component');
  return <AllMarketingExecutions onExecutionSelect={handleExecutionSelect} />;
};

export default MarketingExecutionWrapper; 